import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import React from "react";
import { useToast } from '@chakra-ui/react'
import { useDisclosure } from "@chakra-ui/react";
import {useState} from "react"
import {
  Container,
  Box,
  IconButton,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
} from "@chakra-ui/react";
import { Button, Modal, ModalOverlay } from "@chakra-ui/react";


function Login() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const toast = useToast()
  const navigate = useNavigate();

  const [enteremail, setEnterEmail] = useState("")
  const [enterpassword, setEnterPassword] = useState("");
  const [text,setText] = useState("Login")
  const data = JSON.parse(localStorage.getItem("data"))
  
  const handleLogin = () => {
    if(data.email === enteremail && data.password === enterpassword){
      
        
      toast({
        title: 'Login Successfully.',
        description: "Thanks for Sign-in. We redirected you to Gym Dashboard",
        status: 'success',
        duration: 9000,
        isClosable: true,
      })
      navigate("/trainer")
      onClose();
      
    }
    
    else{
      toast({
        title: 'Login Failed ! Due to Wrong Input.',
        description: "Please enter the valid data in the input field. After that try to Login.",
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
    
  }

  

  return (
    <>
      <Button colorScheme="transparent" onClick={onOpen}>
        {text}
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Login in Your Account</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isRequired>
              <FormLabel>Email</FormLabel>
              <Input ref={initialRef} type="email" placeholder="Enter Email" value={enteremail} onChange = {(e) => setEnterEmail(e.target.value)} />
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Password</FormLabel>
              <Input type="password" placeholder="Enter Password" value={enterpassword} onChange={(e) => setEnterPassword(e.target.value) } />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button  colorScheme="blue" mr={3} onClick={() => handleLogin()}>
              Login
            </Button>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
export default Login;
